import { getTaskIdsInVisibleRange } from './taskHierarchyUtils';

export const isEditableSelectionTarget = target => {
    const element = target instanceof Element ? target : target?.parentElement;
    return Boolean(
        element?.closest?.('input:not([type="checkbox"]), textarea, select, button, [contenteditable="true"], .menu-hover-icon'),
    );
};

export const handleFlatRowSelection = ({ rowId, event, getVisibleIds, lastSelectedIdRef, setSelectedRows }) => {
    const isShiftClick = Boolean(event?.shiftKey || event?.nativeEvent?.shiftKey);

    if (isShiftClick && lastSelectedIdRef.current != null) {
        const rangeIds = getTaskIdsInVisibleRange(getVisibleIds(), lastSelectedIdRef.current, rowId);
        setSelectedRows(prev => Array.from(new Set([...prev, ...rangeIds])));
        return;
    }

    lastSelectedIdRef.current = rowId;
    setSelectedRows(prev => {
        if (isShiftClick) {
            return prev.includes(rowId) ? prev : [...prev, rowId];
        }
        return prev.includes(rowId) ? prev.filter(id => id !== rowId) : [...prev, rowId];
    });
};
